module.exports = __webpack_public_path__ + "img/diogo.3bd3c4fa.png";